
import { UsersApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { ThunkResult } from 'store/store';
import { createAuthenticatedUserContactsFetchFailureAction, createAuthenticatedUserContactsFetchRequestAction, createAuthenticatedUserContactsFetchSuccessAction } from './authenticatedUserContactAction';
import { logError } from 'core/services/common/logging/logger';

export const getAuthenticatedUserContacts = (search = ''): ThunkResult => {
    return async (dispatch) => {
        dispatch(createAuthenticatedUserContactsFetchRequestAction());
        try {
            const response = await UsersApi.getContacts(search);
            dispatch(
                createAuthenticatedUserContactsFetchSuccessAction(response?.contacts || []),
            );
        } catch (error: unknown) {
            logError(error);
            dispatch(createAuthenticatedUserContactsFetchFailureAction());
        }
    };
};